<template>
    <div class="ds-department-settings-panel">
        <div class="ds-department-settings-content">
            <div class="ds-department-settings-title">{{ dep?.name }}</div>
            <div class="ds-department-settings-parent">{{ parent?.name }}</div>

            <div class="ds-department-settings-details">
                <div class="ds-department-settings-detail">
                    <div class="ds-department-settings-label">Регион</div>
                    <div class="ds-department-settings-value">{{ region }}</div>
                </div>
                <div class="ds-department-settings-detail">
                    <div class="ds-department-settings-label">Город</div>
                    <div class="ds-department-settings-value">{{ city }}</div>
                </div>
                <div class="ds-department-settings-detail">
                    <div class="ds-department-settings-label">Таймзона</div>
                    <div class="ds-department-settings-value">{{ timezone }}</div>
                </div>
            </div>

            <div v-if="hasPermissionsToEdit" class="ds-department-settings-section">
                <div class="ds-department-settings-time-fields">
                    <div class="ds-department-settings-field">
                        <div class="ds-department-settings-label">Время открытия</div>
                        <time-picker v-model="opening" />
                    </div>
                    <div class="ds-department-settings-field">
                        <div class="ds-department-settings-label">Время закрытия</div>
                        <time-picker v-model="closing" />
                    </div>
                </div>
                <base-input v-model="address" class="ds-department-settings-address">Адрес</base-input>
                <div class="ds-department-settings-save">
                    <btn @click="save" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">Сохранить</btn>
                </div>
                <div class="ds-department-settings-key">
                    <btn @click="getKey" :disabled="isDisabledKeyBtn" :class="{ 'opacity-50': isDisabledKeyBtn }">Создать
                        код УРВ</btn>
                    <div v-if="keys" class="ds-department-settings-key-value">{{ keys }}</div>
                </div>
            </div>
            <div v-else class="ds-department-settings-details ds-department-settings-section">
                <div class="ds-department-settings-detail">
                    <div class="ds-department-settings-label">Время открытия</div>
                    <div class="ds-department-settings-value">{{ openinig_time }}</div>
                </div>
                <div class="ds-department-settings-detail">
                    <div class="ds-department-settings-label">Время закрытия</div>
                    <div class="ds-department-settings-value">{{ closing_time }}</div>
                </div>
                <div class="ds-department-settings-detail">
                    <div class="ds-department-settings-label">Адрес</div>
                    <div class="ds-department-settings-value">{{ department_address }}</div>
                </div>
            </div>

            <Staff :items="staff" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import TimePicker from '../TimePicker.vue';
import { authKeys } from '@/api/auth';
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useAuthStore } from '@/stores/authStore';
import Staff from '../staff/Staff.vue';
import { useToast } from 'vue-toast-notification';

const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const authStore = useAuthStore()

const hasPermissionsToEdit = computed(() => authStore.permissions?.can_create_department)

const dep = computed(() => departmentStore.departmentsAll.find(item => scheduleStore.currentDepartment?.id === item.id))
const parent = computed(() => departmentStore.departmentsAll.find(item => dep.value?.parent === item.id))
const region = computed(() => dep.value?.region?.name)
const timezone = computed(() => dep.value?.timezone)
const city = computed(() => dep.value?.city?.name)
const isDisabled = ref(true)
const isDisabledKeyBtn = ref(false)
const saveData = ref()
const keys = ref()
const openinig_time = computed(() => dep.value?.opening_time)
const closing_time = computed(() => dep.value?.closing_time)
const department_address = computed(() => dep.value?.address)
const staff = computed(() => departmentStore.staff)
const address = ref(department_address.value)
const opening = ref(openinig_time.value)
const closing = ref(closing_time.value)
const toast = useToast({ position: 'top' })

const checkForChanges = () => {
    const data: any = {}
    if (dep.value?.address !== address.value) {
        isDisabled.value = false
        data.address = address.value
    }
    if (dep.value?.opening_time !== opening.value) {
        isDisabled.value = false
        data.opening_time = opening.value
    }
    if (dep.value?.closing_time !== closing.value) {
        isDisabled.value = false
        data.closing_time = closing.value
    }
    saveData.value = data
}

const save = async () => {
    isDisabled.value = true
    if (dep.value?.id) {
        await departmentStore.changeDepartment(dep.value?.id, saveData.value)
    }

}

const getKey = async () => {
    if (authStore.permissions?.can_create_check_points) {
        isDisabledKeyBtn.value = true
        const dirId = scheduleStore.schedules.find(schedule => schedule.user.id === authStore.userInfo.id)?.id
        const data = {
            name: dep.value?.name,
            department: dep.value?.id,
            director: dirId
        }
        try {
            const res = await authKeys(data)
            if (res.data) {
                keys.value = res.data.body.key
            }
        } catch (error) {
            console.log(error)
        }
    } else {
        toast.error('У вас нет прав на данное действие')
    }

}

watch([opening, closing, address], () => {
    checkForChanges()
})

onMounted(() => {
    if (scheduleStore.currentDepartment)
        departmentStore.fetchStaff(scheduleStore.currentDepartment.id)
})

</script>
